export const swapHandlerUniswapV3Abi = [
  {
    type: "constructor",
    inputs: [
      { name: "uniSwapRouterV3_", type: "address", internalType: "address" },
    ],
    stateMutability: "nonpayable",
  },
  {
    type: "function",
    name: "executeSwap",
    inputs: [
      {
        name: "params",
        type: "tuple",
        internalType: "struct ISwapHandler.SwapParams",
        components: [
          { name: "underlyingIn", type: "address", internalType: "address" },
          { name: "underlyingOut", type: "address", internalType: "address" },
          { name: "mode", type: "uint256", internalType: "uint256" },
          { name: "amountIn", type: "uint256", internalType: "uint256" },
          { name: "amountOut", type: "uint256", internalType: "uint256" },
          {
            name: "exactOutTolerance",
            type: "uint256",
            internalType: "uint256",
          },
          { name: "payload", type: "bytes", internalType: "bytes" },
        ],
      },
    ],
    outputs: [],
    stateMutability: "nonpayable",
  },
  {
    type: "function",
    name: "uniSwapRouterV3",
    inputs: [],
    outputs: [{ name: "", type: "address", internalType: "address" }],
    stateMutability: "view",
  },
] as const
